(function () {

	$(document).ready(() => {

		const cards = $('.team__card');
		const view_xs = 2 * 2, view_sm = 3 * 2, view_md = 5 * 1, view_lg = 7 * 1;
		const point_sm = 351, point_md = 691, point_lg = 993;
		const fade_in_card = 300, fade_in_box = 500;

		renderCards();
		$(window).on('resize', renderCards);

		
		function renderCards() {
			cards.each(function () {
				renderCardTeam($(this));
			});
		}

		function renderCardTeam(card) {
			
			const button = card.find('.team__card__header button');
			const boxes = card.find('.team__card__box');

			button.text('VER TODAS');
			card.fadeIn(fade_in_card);

			const showCardBoxes = (length) => {
				$.each(boxes, function (index) {
					const position = index + 1;
					if (position <= length) {
						$(this).fadeIn(fade_in_box);
					} else {
						$(this).hide();
					}
				});
			}

			const toggleCard = () => {

				if (getWindowWidth() < point_sm) {
					showCardBoxes(view_xs);
				}
				
				if (getWindowWidth() >= point_sm && getWindowWidth() < point_md) {
					showCardBoxes(view_sm);
				}
				
				if (getWindowWidth() >= point_md && getWindowWidth() < point_lg) {
					showCardBoxes(view_md);
				}
				
				if (getWindowWidth() >= point_lg) {
					showCardBoxes(view_lg);
				}

			}

			toggleCard();

			button.on('click', function (e) {
				e.preventDefault();
				e.stopImmediatePropagation();
				
				const status = $(this).text();
				console.log(status);

				if (status === 'VER TODAS') {
					boxes.fadeIn(fade_in_box);
					$(this).text('CERRAR');
				}

				if (status === 'CERRAR') {
					$(this).text('VER TODAS');
					toggleCard();
				}
			});

		}

		function getWindowWidth() {
			return $(window).width();
		}

	});

}());